// @ts-strict-ignore
import { Directive, Input, QueryList, ViewChildren } from '@angular/core';
import { Observable, Observer, of } from 'rxjs';
import { LMThemeService } from '@banner/lm-theme.service';
import { LandmarkPanel, LMRefreshRequest } from '@app/components';

@Directive()
export abstract class LMTwelveColumnPanelBaseComponent {

  @Input() set fromDataView(dataView: LMDataView) {};

  @ViewChildren (LMTwelveColumnPanelBaseComponent) lmTwelveColumnPanelComponentList: QueryList<number>;

  public cardClasses = '';

  constructor(protected lmThemeService: LMThemeService) {}

  isModified(): boolean {
    return false;
  }

  // eslint-disable-next-line no-unused-vars
  public refresh(request?: LMRefreshRequest): Observable<boolean> {
    return of(true);
  }

  save(callBack: Observer<boolean>) {
    callBack.next(true);
    callBack.complete();
  }

  abstract savePanelState(): void;
  abstract clearPanelState(): void;

  protected _setContentClasses(panel: LandmarkPanel) {
    this.cardClasses = 'card columns ';
    switch(panel.spanningColumns) {
      case 1:
        this.cardClasses += 'one';
        break;
      case 2:
        this.cardClasses += 'two';
        break;
      case 3:
        this.cardClasses += 'three';
        break;
      case 4:
        this.cardClasses += 'four';
        break;
      case 5:
        this.cardClasses += 'five';
        break;
      case 6:
        this.cardClasses += 'six';
        break;
      case 7:
        this.cardClasses += 'seven';
        break;
      case 8:
        this.cardClasses += 'eight';
        break;
      case 9:
        this.cardClasses += 'nine';
        break;
      case 10:
        this.cardClasses += 'ten';
        break;
      case 11:
        this.cardClasses += 'eleven';
        break;
      case 12:
      default:
        this.cardClasses += 'twelve';
        break;
    }
  }
}
